// extracted by mini-css-extract-plugin
module.exports = {"mortgage-banner":"a10a3f92e9--mortgage-banner--ATbzm"};